module.exports = "<app-report-menu></app-report-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.html
// module id = ./src/app/reports/reports.component.html
// module chunks = main